const FormattedText = ({ className = '', children }) => (
  <p className={className} style={{whiteSpace: 'pre-line'}}>
    {children}
  </p>
);

export default FormattedText;
